import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import stopPropagation from '@mailobj-browser/front/js/events/hooks/stopPropagation.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import defined from '@mailobj-browser/front/js/tree/defined.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import { close, list } from '#utilities/js/lightboxes/menus/menu.js'
import { cancelable } from './form.js'

const onClick = object(listener, {
  type: click,
  task: (
    button,
    event
  ) => {
    const { dataset, form } = button

    if (cancelable(form, event)) {
      return
    }

    const { confirm, target = '' } = dataset
    const result = globals.ea_form(button, target, confirm)

    if (!result) {
      if (form && list(button)) {
        close()
      }

      preventDefault(event)
      stopPropagation(event)
    }
  }
})

const buttonLoaded = (form, button) => {
  const hasTarget = form.hasAttribute('target')
  const hasType = button.hasAttribute('type')
  const type = button.getAttribute('type')

  if (!hasTarget && (!hasType || type === 'submit')) {
    onClick.listen(button)
  }
}

export default button => {
  const form = closest('form', button)

  if (!form) {
    queueMicrotask(async () => {
      await defined(button, 'form')
      const { form } = button
      buttonLoaded(form, button)
    })
  } else {
    buttonLoaded(form, button)
  }
}
